import {Directive, Input, OnInit, Type, ViewContainerRef} from '@angular/core';
import {SimpleTableCellComponent} from '../components/simple-table-cell/simple-table-cell.component';
import {CategoryValueComponent} from '../components/category-value/category-value.component';
import {ITableCellItem, ITableCellProperties, TableCell} from '../table-cell';
import {ITableColumn} from '../table-column';
import {ITableDataItem} from '../table-data-item';

@Directive({
    selector: '[appTableCellContent]',
})
export class TableCellContentDirective<T extends ITableCellProperties> implements OnInit {
    private cell: TableCell;
    private column: ITableColumn;
    private row: ITableDataItem;

    @Input('appTableCellContent') set content(content) {
        const [row, column] = content;
        this.column = column as ITableColumn;
        this.row = row as ITableDataItem;
        
        // Determine which component to use based on column type
        let componentType = column?.cell ? column.cell : SimpleTableCellComponent;
        
        // Check if this is a category column
        if (column.field && column.field.startsWith('category_')) {
            componentType = CategoryValueComponent;
        }
        
        const cell =  new TableCell(componentType, {
            dataItem: row as ITableDataItem ,
            columnOptions: column as ITableColumn
        });

        const previousCell = this.cell;

        this.cell = cell as TableCell;

        // re-render component if it changes
        if (this.cell !== previousCell) {
            const {component, properties} = this.cell;
            this.render(component, properties as unknown as T);
        }
    }

    constructor(public viewContainerRef: ViewContainerRef) {
    }

    ngOnInit(): void {
        const {component, properties} = this.cell;
        this.render(component, properties as unknown as T);
    }

    private render(component: Type<ITableCellItem>, data: T) {
        this.viewContainerRef.clear();
        const componentRef = this.viewContainerRef.createComponent(component);
        Object.keys(data).forEach(key => (componentRef.instance[key] = data[key]));
    }
}